// src/services/raveAlertService.js

/**
 * Service for fetching and parsing Rave alert data
 */
export async function fetchRaveData() {
  const capParser = new DOMParser();
  const capURL = "https://content.getrave.com/cap/viterbo/channel2?" + Math.floor(Math.random() * 1000);
  
  try {
    const response = await fetch(capURL);
    if (!response.ok) {
      throw new Error(`Network response was not ok: ${response.status}`);
    }
    
    // Get the RAVE xml and parse into variables
    const capText = await response.text();
    const capXML = capParser.parseFromString(capText, "text/xml");

    const statusTag = capXML.querySelector("status")?.textContent || "";
    const responseTypeTag = capXML.querySelector("responseType")?.textContent || "";
    const headlineTag = capXML.querySelector("headline")?.textContent || "";
    const descriptionTag = capXML.querySelector("description")?.textContent || "";

    return {
      status: statusTag,
      responseType: responseTypeTag,
      headline: headlineTag,
      description: descriptionTag
    };
  } catch (error) {
    console.error("Error fetching RAVE data:", error);
    // Return safe defaults if fetch fails
    return {
      status: "",
      responseType: "allclear",
      headline: "",
      description: ""
    };
  }
}

/**
 * Determines if alert should be active based on response type
 * @param {Object} raveData - Data returned from fetchRaveData
 * @returns {Object} - Alert status and display data
 */
export function processRaveData(raveData) {
  const isActive = raveData.responseType.toLowerCase() !== "allclear";
  
  return {
    isActive,
    title: raveData.headline || "Alert",
    description: raveData.description || "",
    rawData: raveData
  };
}